import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

// Register the launchpad as a routable page at `/`. `noHeader` lets HomePage
// render its own <Header>, and the catalog page is moved off `/` to `/catalog`
// in app-config.yaml so this becomes the landing page.
const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return <HomePage />;
    },
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
